import React from "react";
import { EC_TextArea } from "../../../../../UiComponents";

export default function Heading({ value, onChange, onFocusOut }) {
  return (
    <EC_TextArea
      // label="Heading"
      onChange={onChange}
      value={value}
      onFocusOut={onFocusOut}
    />
  );
}
